export default class LocationsMap {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const self = this;
        const maps = document.querySelectorAll('.locations-map');
        if (maps) {
            maps.forEach((map) => {
                self.initMap(map);
            });
        }
    }

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   el The element
     * @return  object The map instance.
     */
    initMap(el) {
        // Find marker elements within map.
        var markers = el.querySelectorAll('.marker');

        // Create generic map.
        var mapArgs = {
            zoom: el.dataset.zoom || 14,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            draggable: false
        };
        var map = new google.maps.Map(el, mapArgs);

        // Add markers.
        map.markers = [];
        for (var i = 0; i < markers.length; i++) {
            this.initMarker(markers[i], map);
        }

        // Center map based on markers.
        this.centerMap(map);

        el.classList.remove('loading');

        // Return map instance.
        return map;
    }

    initMarker(markerEl, map) {
        // Get position from marker.
        var lat = markerEl.dataset.lat;
        var lng = markerEl.dataset.lng;
        var latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };

        var marker_color = markerEl.getAttribute('data-color');

        if (marker_color === '') {
            marker_color = 'yellow';
        }

        var marker_link = markerEl.getAttribute('data-url');
        var marker_url = window.location.origin + '/wp-content/plugins/royalhomes-plugin/assets/images/marker_' + marker_color + '.png';

        // Create marker instance.
        var marker;
        if (markerEl.hasAttribute('data-url')) {
            // Marker has link
            marker = new google.maps.Marker({
                url: marker_link,
                position: latLng,
                map: map,
                icon: marker_url
            });
        } else {
            // Marker doesn't have link
            marker = new google.maps.Marker({
                position: latLng,
                map: map,
                icon: marker_url
            });
        }

        // Append to reference for later use.
        map.markers.push(marker);

        // Add links to markers
        if (markerEl.hasAttribute('data-url')) {
            google.maps.event.addListener(marker, 'click', function () {
                const targetElement = document.querySelector(marker.url);
                if (targetElement) {
                    targetElement.scrollIntoView({behavior: 'smooth'});
                    // Remove previous highlights, highlight new centre
                    const centreHighlights = document.querySelectorAll('.centre-highlight');
                    if (centreHighlights) centreHighlights.forEach((el) => el.classList.remove('centre-highlight'));
                    targetElement.classList.add('centre-highlight');
                }
            });
        }

        // if marker contains HTML, add it to an infoWindow
        if (markerEl.innerHTML) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: markerEl.innerHTML
            });

            // show/hide info window when marker is hovered/clicked
            google.maps.event.addListener(marker, 'mouseover', function () {
                infowindow.open(map, marker);
            });
            google.maps.event.addListener(marker, 'mouseout', function () {
                infowindow.close();
            });
        }
    }

    centerMap(map) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());

            // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }
}